import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(({ }) => ({
    specialCharacters: {
        'font-family': "Helvetica, Arial, sans-serif"
    }
}));
